module.exports = __webpack_public_path__ + "static/no-data.71bee8c9.png";